module.exports = "https://w.yxzs.360.cn/singleapp/simulator-site-old/img/p2_title.79115932.png";